import type { ReactNode } from 'react'
import React from 'react'
import type { PageTitleProps as BasePageTitleProps } from '@ztechapps/webui.page'
import { PageTitle as BasePageTitle } from '@ztechapps/webui.page'

export interface PageTitleProps extends Omit<BasePageTitleProps, 'noTitleTag'> {
  /**
   * Whether to render the title as an h1 tag in the content
   * @default false
   */
  showTitleInContent?: boolean
  children?: ReactNode
}

/**
 * Wrapper around the base PageTitle component with PanelPunches-specific defaults
 *
 * @example
 * // Basic usage
 * <PageTitle title="Page Title" />
 *
 * @example
 * // With custom description and keywords
 * <PageTitle
 *   title="Products"
 *   description="Browse our collection of high-quality products"
 *   keywords={['products', 'catalog', 'shopping']}
 * />
 *
 * @example
 * // Show title in content
 * <PageTitle
 *   title="About Us"
 * />
 */
export const PageTitle = ({
  title,
  description = 'PanelPunches - Your premier source for high-quality panel punches and metal fabrication tools, maker of die cast machines from USA',
  keywords = [
    'panel punches',
    'metal fabrication',
    'tools',
    'metalworking',
    'professional tools',
    'industrial tools',
    'metal working equipment',
  ],
  siteName = 'PanelPunches',
  children,
  ...props
}: PageTitleProps) => {
  return (
    <BasePageTitle
      title={title}
      description={description}
      keywords={keywords}
      siteName={siteName}
      noTitleTag={true}
      {...props}
    >
      {children}
    </BasePageTitle>
  )
}

export default PageTitle
